import { Component, OnInit, OnDestroy, AfterViewInit, Injector, Output, EventEmitter } from '@angular/core';
import { AppComponentBase } from '../../services/AppComponentBase';
import { MobileMainView } from '../../enums/mobile-mainViews';
import { callNextAsync } from '../../services/BaseService';
import { WolfieContextMenuComponent } from '../wolfie-context-menu/wolfie-context-menu.component';
import { WolfieContextMenuService } from '../../services/wolfie-context-menu/wolfie-context-menu.service';
import { MenuItem } from '../wolfie-context-menu/menu-item';

@Component({
  selector: 'app-mobile-header',
  template: require('./mobile-header.component.html'),
  styles: [require('./mobile-header.component.css')]
})
export class MobileHeaderComponent extends AppComponentBase implements OnDestroy, OnInit, AfterViewInit {

  @Output('update')
  change: EventEmitter<MobileMainView> = new EventEmitter<MobileMainView>();



  increment() {
    this.change.emit(this.currentView);
  }

  protected contextMenuService: WolfieContextMenuService;

  constructor(
    injector: Injector,
  ) {
    super(injector);
    this.contextMenuService = injector.get(WolfieContextMenuService);
   }



  private _currentView: MobileMainView = this.workspace.mobileView;
  public get currentView (): MobileMainView {
    return this.workspace.mobileView;
  }

  public set currentView ( value: MobileMainView ) {
    this.workspace.mobileView = value;
    this.increment();
  }


  public showMobileLandingPageAction()
  {
      this.workspace.showMobileLandingPage = true;
      this.workspace.showScannerPage = false;
      this.workspace.mobileView = MobileMainView.PANEL;
      this.workspace.showMobileLandingPage = true;
  }







  public mobileMainViewENUM = MobileMainView;

  ngOnInit() {
  }

  ngOnDestroy()
  {

  }

  ngAfterViewInit()
  {

  }

}
